<template>
    <div v-if="hasInvoice && !forceTaxOnDeposit()">
        <h3 class="mt-0">
            {{ $l10n.__("Appliquer la TVA sur les factures d'acompte") }}
        </h3>
        <div class="form-group">
            <CompassCheckbox
                modelValue="taxOnDeposit"
                :label="$l10n.__('Appliquer la TVA sur les factures d\'acompte')"
                :checked="tax.includes('taxOnDeposit')"
                @change="handleChange('taxOnDeposit', $event)"
            />
        </div>
    </div>

            <h3 :class="{ 'mt-0': !hasInvoice }">
                {{ $l10n.__('Assiette de TVA') }}
            </h3>
            <p>
                {{
                    $l10n.__(
                        "L'assiette de TVA est la base sur laquelle le montant de la TVA sera calculé",
                    )
                }}
            </p>
            <div class="form-group">
                <CompassCheckbox
                    modelValue="vatBase"
                    :label="$l10n.__('Afficher l\'assiette de TVA')"
                    :checked="tax.includes('vatBase')"
                    @change="handleChange('vatBase', $event)"
                />
            </div>
            <CompassAlert
                v-if="useForceVatBaseDisplay()"
                type="warning"
                :showClose="false"
                :description="
                    $l10n.__(
                        'L\'assiette de TVA sera toujours affichée pour tous les documents comptables (factures, avoirs).',
                    )
                "
            />
            <div v-if="useDoubleVat()" class="alert alert-warning">
                <p>
                    {{
                        $l10n.__(
                            "L'assiette de TVA n‘est pas disponible sur les documents utilisant la double taxe",
                        )
                    }}
                </p>
            </div>

            <template v-if="useDoubleVat()">
                <h3>
                    {{ $l10n.__('Double taxe') }}
                </h3>
                <p>
                    {{ $l10n.__('Certains pays ou territoires utilisent deux taxes différentes.') }}
                    {{
                        $l10n.__(
                            'Activez cette préférence si vous souhaitez que tous vos documents comportent deux colonnes de taxe.',
                        )
                    }}
                    {{
                        $l10n.__('Cette préférence peut aussi être activée document par document.')
                    }}
                </p>
                <div class="form-group">
                    <CompassCheckbox
                        modelValue="doubleVat"
                        :label="$l10n.__('Utiliser la double taxe dans les documents')"
                        :checked="tax.includes('doubleVat')"
                        @change="handleChange('doubleVat', $event)"
                    />
                </div>
            </template>

    <div class="mt-3">
        <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
    </div>
</template>

<script>
import Feature from 'Services/Feature';
export default {
    props: {
        defaultTax: {
            type: Array,
            required: true,
        },
        docPrefsId: {
            type: Number,
            required: true,
        },
        hasInvoice: {
            type: Boolean,
            required: true,
        },
    },
    data: function () {
        return {
            tax: this.defaultTax,
        };
    },
    methods: {
        useDoubleVat: function () {
            return Feature.isEnabled('double-vat');
        },
        forceTaxOnDeposit: function () {
            return Feature.isEnabled('force-tax-on-deposit');
        },
        useForceVatBaseDisplay: function () {
            return Feature.isEnabled('force-vat-base-display');
        },
        handleChange(value, checked) {
            if (checked) {
                this.tax.push(value);
            } else {
                this.tax = this.tax.filter((item) => item !== value);
            }
        },
        save: function () {
            const options = {
                tax: this.tax,
            };

            this.$ajax.put(
                `/rest/documents/tax-preferences/${this.docPrefsId}`,
                {},
                options,
                () => {
                    Push.success(this.$l10n.__('Préférences enregistrées'));
                },
                (error) => {
                    const messages = error.response.data.error.message;
                    Object.keys(messages).forEach(function (key) {
                        Push.error(messages[key]);
                    });
                },
            );
        },
    },
};
</script>
